export default {
  path: '/account',
  component: () => import('../components/Index'),
  children: [
    {
      path: "login",
      meta:{
        hideHeader:true,
        hideFotter:true,
        fullScreen:true,
      },
      component: () => import('../components/account/Login'),
    }
  ],
}



// WEBPACK FOOTER //
// ./src/pages/pc/router/account.js